export default __webpack_public_path__ + "static/angajati-si-societate-label-5a2d2f51c9eff21f5eba1268cab06f8e.png";